var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.213,
    height: 31.999,
    viewBox: "0 0 23.213 31.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6764",
    "data-name": "Group 6764",
    transform: "translate(413.247 -718.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53511",
    "data-name": "Path 53511",
    d: "M-393.988,724.99c0,.192,0,.384,0,.577l3.661-3.662a1,1,0,0,0,0-1.414,1,1,0,0,0-1.414,0l-2.539,2.539a6.7,6.7,0,0,1,.254,1.229A6.87,6.87,0,0,1-393.988,724.99Z",
    fill: "#e8585d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53512",
    "data-name": "Path 53512",
    d: "M-394.026,724.259a6.7,6.7,0,0,0-.254-1.229,6.669,6.669,0,0,0-7.089-4.69,6.569,6.569,0,0,0-5.856,5.874c-.122,1.633-.022,3.282-.022,4.924h-.049c0,1.407-.018,2.813,0,4.219a6.611,6.611,0,0,0,.45,2.241,6.619,6.619,0,0,0,1.036,1.792l11.822-11.822c0-.193,0-.385,0-.577A6.87,6.87,0,0,0-394.026,724.259Z",
    fill: "#e8585d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53513",
    "data-name": "Path 53513",
    d: "M-407.548,737.421a7.928,7.928,0,0,1-.389-.734,7.957,7.957,0,0,1-.811-3.475,1.08,1.08,0,0,0-.005-.113,1.063,1.063,0,0,0-1.158-.958c-.033,0-.065,0-.1.005a1.05,1.05,0,0,0-.944,1.146,13.935,13.935,0,0,0,.484,3.03,10.009,10.009,0,0,0,.88,2.016l-3.367,3.367a1,1,0,0,0,0,1.414,1,1,0,0,0,1.414,0l3.1-3.1,1.593-1.593A7.721,7.721,0,0,1-407.548,737.421Z",
    fill: "#e8585d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53514",
    "data-name": "Path 53514",
    d: "M-391.361,732.134a1.109,1.109,0,0,0-1.183,1.031q-.048.849-.179,1.69a8.032,8.032,0,0,1-7.7,6.443,7.811,7.811,0,0,1-4.963-1.508l-1.6,1.6a10.013,10.013,0,0,0,4.845,2.036c.329.056.384.179.384.471-.014,1.253-.006,2.505-.006,3.758v.424h-.423c-.693,0-1.393-.009-2.093,0a1.079,1.079,0,0,0-.15,0,1.112,1.112,0,0,0-1.033,1.187,1.113,1.113,0,0,0,1.188,1.033q3.635.009,7.271,0a.987.987,0,0,0,.133,0,1.112,1.112,0,0,0,1.044-1.177A1.112,1.112,0,0,0-397,748.076c-.709-.006-1.419,0-2.128,0-.125,0-.25-.011-.385-.017V743.5l.279-.05a10.335,10.335,0,0,0,8.907-10.174A1.11,1.11,0,0,0-391.361,732.134Z",
    fill: "#e8585d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53515",
    "data-name": "Path 53515",
    d: "M-404.328,738.732a6.592,6.592,0,0,0,3.744,1.126,6.655,6.655,0,0,0,6.6-6.714q0-2.376,0-4.752Z",
    fill: "#e8585d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/Unmute.887451d98b2c04b67df8dfab0b729f91.svg";
export { ForwardRef as ReactComponent };